export type ErrorWithMessage = {
    message: string
}

export const isErrorWithMessage = (error: unknown): error is ErrorWithMessage  => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  )
}

export const toErrorWithMessage = (maybeError: unknown): ErrorWithMessage => {
  if (isErrorWithMessage(maybeError)) return maybeError
  try {
    return new Error(JSON.stringify(maybeError))
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError))
  }
}

export const getErrorMessage = (error: unknown):string => {
    return toErrorWithMessage(error).message
}

// Extract error message from react-hook-form field error. Handles both string and object error formats from zod/react-hook-form
export const getFormFieldErrorMessage = (
  fieldError: string | { message?: string } | undefined,
  fallbackMessage?: string
): string => {
  if (!fieldError) return fallbackMessage || '';
  if (typeof fieldError === 'string') return fieldError;
  return fieldError?.message || fallbackMessage || '';
};